module.exports = __webpack_public_path__ + "img/join2-1.5528a2fc.jpg";